import styled, { keyframes } from 'styled-components';

const rotation = keyframes`
 0% { transform: rotate(0deg); }
 100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div<{
  variant: 'primary' | 'secondary' | 'error' | 'tertiary' | 'custom';
  size: 'small' | 'large' | 'medium' | 'xlarge';
  colors?: [main: string, secondary: string];
}>`
  border-style: solid;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotation} 0.6s linear infinite;
  ${(props) => {
    switch (props.size) {
      case 'small':
        return `width: 12px; height: 12px; border-width: 3px;`;
      case 'medium':
        return `width: 22px; height: 22px; border-width: 5px;`;
      case 'large':
        return `width: 28px; height: 28px; border-width: 6px;`;
      case 'xlarge':
        return `width: 80px; height: 80px; border-width: 10px;`;
    }
  }};
  ${(props) => {
    switch (props.variant) {
      case 'primary':
        return `border-color: ${props.theme.atlas.semantic.color.ui.loading.default};
        border-bottom-color:
          ${props.theme.atlas.semantic.color.action.primary.onPrimary};`;
      case 'secondary':
        return `border-color: ${props.theme.atlas.semantic.color.action.secondary.hoverFill};
        border-bottom-color:
          ${props.theme.atlas.semantic.color.action.primary.default}`;
      case 'tertiary':
        return `border-color: ${props.theme.atlas.core.color.gray[200]};
        border-bottom-color:
          ${props.theme.atlas.semantic.color.type.default};`;
      case 'error':
        return `border-color: ${props.theme.atlas.core.color.red[60]};
        border-bottom-color:
          ${props.theme.atlas.semantic.color.action.destructive.onDestructive};`;
      case 'custom':
        return `border-color: ${props.colors?.[0]};
        border-bottom-color:
          ${props.colors?.[1]};`;
    }
  }};
`;
